"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cCurrencyCodesZod = void 0;
var zod_1 = require("zod");
var constants_1 = require("./constants");
exports.cCurrencyCodesZod = zod_1.z.enum(constants_1.cCurrencyCodes);
